export enum MAGNET_PAGE_PATHS {
  ESA = "esa",
  ARTICLES = "articles",
  HOMESCHOOL = "homeschool",
  HOW_TO_TEACH = "how-to-teach",
  STUDY_TIPS = "study-tips",
  HOMESCHOOL_CURRICULUM = "homeschool-curriculum"
}

export const MAX_WIDTH = "692px";

export const TOPICS = [
  "ADHD",
  "Drawing",
  "Reading",
  "Singing",
  "Chess",
  "Cooking and Baking",
  "Writing",
  "Spanish",
  "Social Skills",
  "Speech",
  "Gaming",
  "Piano",
  "Coding",
  "Acting",
  "Science",
  "Anime",
  "Minecraft"
];
